var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.97 36.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff82bf",
    d: "m17.19,8.53v8.66h-8.66C3.82,17.19,0,13.37,0,8.66V0h8.66c4.71,0,8.53,3.82,8.53,8.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce4a87",
    d: "m28.31,0C23.6,0,19.78,3.82,19.78,8.53v8.66h8.66c4.71,0,8.53-3.82,8.53-8.53V0h-8.66Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#870040",
    d: "m28.44,19.78h-8.66v8.66c0,4.71,3.82,8.53,8.53,8.53h8.66v-8.66c0-4.71-3.82-8.53-8.53-8.53Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce4a87",
    d: "m8.53,19.78c-4.71,0-8.53,3.82-8.53,8.53v8.66h8.66c4.71,0,8.53-3.82,8.53-8.53v-8.66h-8.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8b20ae08a2893d00873ce89b311ef49b.svg";
export { ForwardRef as ReactComponent };